import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Translate from 'translate';
import IconProgress from 'material-ui/CircularProgress';
import IconBarProgress from 'material-ui/LinearProgress';
import ConfigurationService from 'services/ConfigurationService'
import { toggleLoading, updateApiStatus } from 'stores/actions/';
import APPCONFIG from 'constants/Config';
import AppInfoModalEvents from '../AppInfoModalEvents';
import Uptime from '../Uptime';
import async from 'async';
class AppInfoModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
      appInfoModalEventOpened: false,
    };
    
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.getData()
      //this.getStatusData()
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    // console.log(nextState.data, this.state.data)
    return true

    /* ( (lat !== nextProps.lat) || (lng !== nextProps.lng) || (defaultZoom !== nextProps.defaultZoom) ){
      return true;
    } else {
      return false;
    }*/
    
  }
  toggleAppInfoEventModal = () => {
    this.setState( { appInfoModalEventOpened: !this.state.appInfoModalEventOpened } )
  };



  getData() {
    //this.props.toggleLoading( true );
    let data = {};
    async.parallel({
        api1: ( cb ) => {
          ConfigurationService.getAppConfiguration(  ).then( ( response ) => {
            if( response.errors ) return cb( null, { incmsApiStatus: 'KO' } );
            return cb( null, response.data  );
          } );
       },
    
        api2: ( cb ) => {
          //return cb( null, { ...data, api: {} } );
      
          ConfigurationService.getComponentStatus().then( ( response ) => {
            if( response.errors ) return cb( null, {  
              dbStatus: {status: 'KO', statusDay: 0 },
              whatsappStatus: {status: 'KO', statusDay: 0 },
              incmsApiObj: {status: 'KO', statusDay: 0 },
              facebookStatus: {status: 'KO', statusDay: 0 },
              twitterStatus: {status: 'KO', statusDay: 0 },
              emailStatus: {status: 'KO', statusDay: 0 },
              smsStatus: {status: 'KO', statusDay: 0 }, 
            }  );
            const whatsappStatus = _.find(response.data.data, { 'code': 'whatsapp_status'});
            const dbStatus = _.find(response.data.data, { 'code': 'db_status'});
            const incmsStatus = _.find(response.data.data, { 'code': 'incms_status'});
            const facebookStatus = _.find(response.data.data, { 'code': 'facebook_status'});
            const twitterStatus = _.find(response.data.data, { 'code': 'twitter_status'});
            const emailStatus = _.find(response.data.data, { 'code': 'email_status'});
            const smsStatus = _.find(response.data.data, { 'code': 'sms_status'});
            return cb( null, { 
              dbStatus: dbStatus,
              whatsappStatus: whatsappStatus,
              incmsApiObj: incmsStatus,
              facebookStatus: facebookStatus,
              twitterStatus: twitterStatus,
              emailStatus: emailStatus,
              smsStatus: smsStatus,
            }  );
          } );
        }
    
    }, (err, results) => {
        if( err ) return this.props.toggleAlertError( 'Invalid username or password' );

        if( !err ) {
          data = { ...results.api1, ...results.api2};
          //console.log({ ...results.api1, ...results.api2});
          this.props.updateApiStatus( {
            incmsApiStatus: results.api2.incmsApiObj.status,
            dbStatus: results.api2.dbStatus.status.status,
            whatsappStatus: results.api2.whatsappStatus.status,
            facebookStatus: results.api2.facebookStatus.status,
            twitterStatus: results.api2.twitterStatus.status,
            emailStatus: results.api2.emailStatus.status,
            phoneStatus: 'OK',
          } )
          this.setState( {data} )
        }
    });

    /*ConfigurationService.getAppConfiguration().then( ( response ) => {
      //this.props.toggleLoading( false );

      if( response.data ) {
        this.setState( { data: response.data } );
        this.props.updateApiStatus( {
          incmsApiStatus: response.data.incmsApiStatus
        } )
      }
    } );*/
  }
  getApiStatus = ( cb ) => {
    //return cb( null, { ...data, api2: {} } );
    ConfigurationService.getAppConfiguration(  ).then( ( response ) => {
      if( response.errors ) return cb( null, {  api1: { incmsApiStatus: 'KO' } } );
      return cb( null, { 
        api1: response.data } );
    } );
  };
  getServiceStatus = ( cb ) => {
    //return cb( null, { ...data, api: {} } );

    ConfigurationService.getComponentStatus().then( ( response ) => {
      if( response.errors ) return cb( null, {  api2: {
        dbStatus: 'KO',
        whatsappStatus: 'KO',
        incmsStatus: 'KO',
        facebookStatus: 'KO',
        twitterStatus: 'KO',
        emailStatus: 'KO',
        smsStatus: 'KO', 
        incmsApiStatus: 'KO' 
      } } );
      const whatsappStatus = _.find(response.data.data, { 'code': 'whatsapp_status'});
      const dbStatus = _.find(response.data.data, { 'code': 'db_status'});
      const incmsStatus = _.find(response.data.data, { 'code': 'incms_status'});
      const facebookStatus = _.find(response.data.data, { 'code': 'facebook_status'});
      const twitterStatus = _.find(response.data.data, { 'code': 'twitter_status'});
      const emailStatus = _.find(response.data.data, { 'code': 'email_status'});
      const smsStatus = _.find(response.data.data, { 'code': 'sms_status'});
      return cb( null, { api2: {
        dbStatus: dbStatus.status,
        whatsappStatus: whatsappStatus,
        incmsApiObj: incmsStatus,
        facebookStatus: facebookStatus,
        twitterStatus: twitterStatus,
        emailStatus: emailStatus,
        smsStatus: 'OK',
      } } );
    } );
  };

 
  divLoading = () => {

      return (
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      )

  }
  closeModal = () => {
    this.setState( { data: {} } );
    this.props.onClose()
  };

  render() {
    const { open } = this.props;
    const { data, appInfoModalEventOpened } = this.state;
    //console.log('data :>> ', data);

    return (
      <Modal closeOnEsc={false}
             modalClassName="col-md-5"
             open={open}
             onClose={this.closeModal}>
        <h5 className="mt-0"><Translate id="appInfo"/></h5>

        <div className="row">
          <div className="col-sm-6">
            <div className="row pt-2">
              <div className="col-sm-6"><strong><Translate id="webVersion"/>:</strong> </div>
              <div className="col-sm-6">{APPCONFIG.version || '---'}</div>
            </div>
          </div>
          
          <div className="col-sm-6">
            <div className="row pt-2">
              <div className="col-sm-6"><strong><Translate id="apiVersion"/>:</strong></div>
              <div className="col-sm-6"> {data.apiVersion ? data.apiVersion || '---' : <IconProgress color="#3bd671"  size={20} disableShrink/> }</div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="row pt-2">
              <div className="col-sm-6"><strong><Translate id="modelVersion"/>:</strong> </div>
              <div className="col-sm-6">{data.modelVersion ? data.modelVersion || '---' : <IconProgress color="#3bd671"  size={20} disableShrink/> }</div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="row pt-2">
              <div className="col-sm-6"><strong><Translate id="phpVersion"/>:</strong></div>
              <div className="col-sm-6"> {data.phpVersion ? data.phpVersion || '---' : <IconProgress color="#3bd671"  size={20} disableShrink/> }</div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="row pt-2">
              <div className="col-sm-6"><strong><Translate id="branch"/>:</strong></div>
              <div className="col-sm-6"> {data.branch ? data.branch.substring(0,50) || '---' : <IconProgress color="#3bd671"  size={20} disableShrink/> }</div>
            </div>
          </div>
          <div className='col-sm-6' />
          <div className="col-sm-12">
            <div className="row pt-2">
              <div className="col-sm-3"><strong><Translate id="commit"/>:</strong> </div>
              <div className="col-sm-9">{data.stringfromfile ? data.stringfromfile || '---' : <IconProgress color="#3bd671" size={20} disableShrink/> }</div>
            </div>
          </div>
         
        </div>
        {/* <div className="row"> 
          <div className='col-sm-2'>
            <div className='card pointer'>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}}><Translate id="incmsStatus"/></div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-gear color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-gear color-success ml-1"/>}
              </div>
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='card pointer'>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}}><Translate id="database"/></div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-database color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-database color-success ml-1"/>}
              </div>
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='card pointer'>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}}><Translate id="network"/></div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-wifi color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-wifi color-success ml-1"/>}
              </div>
            </div>
          </div>
        </div> */}
        
        <div className="row">
          <div className="box box-default" style={{width:'100%'}}>
            <div className="box-body">
              <table class="table table-borderless">
                <thead>
                  <tr >
                    <th scope="col"></th>
                    <th scope="col" style={{textAlign: 'center'}}><Translate id="uptimeDayPercent"/></th>
                    <th scope="col" style={{textAlign: 'center'}}><Translate id="uptimeCurrentStatus"/></th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                    <th scope="row" style={{width:'27%'}}>API Status<i className="fa fa-angle-right ml-2" style={{width:25, height:25}}/></th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      {data.incmsApiObj ?  <Uptime id="apiUptime" week={data.incmsApiObj.statusLastWeek} month={data.incmsApiObj.statusLastMonth} percent={data.incmsApiObj.statusDay}/> || '---' : <IconBarProgress color="#3bd671" size={20} disableShrink/> } 
                      
                    </td>
                    <td style={{textAlign: 'center'}}>
                      {data.incmsApiObj ? ''|| '' : <IconProgress color="#3bd671" size={20} disableShrink/> }
                        {data && data.incmsApiObj && data.incmsApiObj.status === 'KO' && <i className="fa fa-warning color-danger ml-1"/>}
                        {data && data.incmsApiObj && data.incmsApiObj.status === 'OK' && <i className="fa fa-check color-success ml-1"/>} 
                      {/* <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span> */}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row"  style={{width:'27%'}}>Database<i className="fa fa-angle-right ml-2" style={{width:25, height:25}}/></th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      {data.dbStatus ?  <Uptime id="databaseUptime"  week={data.dbStatus.statusLastWeek} month={data.dbStatus.statusLastMonth}  percent={data.dbStatus.statusDay}/> || '---' : <IconBarProgress color="#3bd671" size={20} disableShrink/> } 
                    </td>
                    <td style={{textAlign: 'center'}}>
                      {data.dbStatus ? ''|| '' : <IconProgress color="#3bd671" size={20} disableShrink/> }
                      {data && data.dbStatus && data.dbStatus.status === 'KO' && <i className="fa fa-warning color-danger ml-1"/>}
                      {data && data.dbStatus && data.dbStatus.status === 'OK' && <i className="fa fa-check color-success ml-1"/>} 
                    </td>
                  </tr>

                  <tr>
                    <th scope="row"  style={{width:'27%'}} >Facebook<i className="fa fa-angle-right ml-2" style={{width:25, height:25}}/></th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      
                      {data.facebookStatus ?  <Uptime id="faceUptime"  week={data.facebookStatus.statusLastWeek} month={data.facebookStatus.statusLastMonth} percent={data.facebookStatus.statusDay}/> || '---' : <IconBarProgress color="#3bd671" size={20} disableShrink/> } 
                    </td>
                    <td style={{textAlign: 'center'}}>
                      {data.facebookStatus ? ''|| '' : <IconProgress color="#3bd671" size={20} disableShrink/> }
                      {data && data.facebookStatus && data.facebookStatus.status === 'KO' && <i className="fa fa-warning color-danger ml-1"/>}
                      {data && data.facebookStatus && data.facebookStatus.status === 'OK' && <i className="fa fa-check color-success ml-1"/>} 
                      {/* <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span> */}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row"  style={{width:'27%'}} >Twitter<i className="fa fa-angle-right ml-2" style={{width:25, height:25}}/></th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      
                      {data.twitterStatus ?  <Uptime id="twitterUptime" week={data.twitterStatus.statusLastWeek} month={data.twitterStatus.statusLastMonth}  percent={data.twitterStatus.statusDay}/> || '---' : <IconBarProgress color="#3bd671" size={20} disableShrink/> } 
                    </td>
                    <td style={{textAlign: 'center'}}>
                      {data.twitterStatus ? ''|| '' : <IconProgress color="#3bd671" size={20} disableShrink/> }
                      {data && data.twitterStatus && data.twitterStatus.status === 'KO' && <i className="fa fa-warning color-danger ml-1"/>}
                      {data && data.twitterStatus && data.twitterStatus.status === 'OK' && <i className="fa fa-check color-success ml-1"/>} 
                      {/* <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span> */}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" style={{width:'27%'}} >Email<i className="fa fa-angle-right ml-2" style={{width:25, height:25}}/></th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      
                      {data.emailStatus ?  <Uptime id="emailUptime"  week={data.emailStatus.statusLastWeek} month={data.emailStatus.statusLastMonth} percent={data.emailStatus.statusDay}/> || '---' : <IconBarProgress color="#3bd671" size={20} disableShrink/> } 
                    </td>
                    <td style={{textAlign: 'center'}}>
                      {data.emailStatus ? ''|| '' : <IconProgress color="#3bd671" size={20} disableShrink/> }
                      {data && data.emailStatus && data.emailStatus.status === 'KO' && <i className="fa fa-warning color-danger ml-1"/>}
                      {data && data.emailStatus && data.emailStatus.status === 'OK' && <i className="fa fa-check color-success ml-1"/>} 
                    </td>
                  </tr>
                  {/*<tr>
                    <th scope="row"  style={{width:'27%'}} >SMS<i className="fa fa-angle-right ml-2" style={{width:25, height:25}}/></th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      
                      {data.smsStatus ?  <Uptime id="smsUptime"  week={data.smsStatus.statusLastWeek} month={data.smsStatus.statusLastMonth} percent={data.smsStatus.statusDay}/> || '---' : <IconBarProgress color="#3bd671"  disableShrink/> } 
                    </td>
                    <td style={{textAlign: 'center'}}>
                      {data.smsStatus ? ''|| '' : <IconProgress color="#3bd671" size={20} disableShrink/> }
                      {data && data.smsStatus && data.smsStatus.status === 'KO' && <i className="fa fa-warning color-danger ml-1"/>}
                      {data && data.smsStatus && data.smsStatus.status === 'OK' && <i className="fa fa-check color-success ml-1"/>} 
                    </td>
                  </tr>
                  */}
                  {/**
                  <tr>
                    <th scope="row" style={{width:'25%'}} onClick={this.toggleAppInfoEventModal}>Whatsapp <i className="fa fa-angle-right ml-2" style={{width:25, height:25}}/></th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      
                      {data.whatsappStatus ?  <Uptime id="whatsappUptime"  week={data.whatsappStatus.statusLastWeek} month={data.whatsappStatus.statusLastMonth} percent={data.whatsappStatus.statusDay}/> || '---' : <IconBarProgress color="#3bd671" size={20} disableShrink/> } 
                    </td>
                    <td style={{textAlign: 'center'}}>
                      {data.whatsappStatus ? ''|| '' : <IconProgress color="#3bd671" size={20} disableShrink/> }
                      {data && data.whatsappStatus && data.whatsappStatus.status === 'KO' && <i className="fa fa-warning color-danger ml-1"/>}
                      {data && data.whatsappStatus && data.whatsappStatus.status === 'OK' && <i className="fa fa-check color-success ml-1"/>} 
                    </td>
                  </tr>
                  */}

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className='row' style={{display:'none'}}>
          <div className='col-sm-2'>
            <div className='card pointer' onClick={()=> alert("Ejemplo")}>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}} >Facebook</div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-facebook color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-facebook color-success ml-1"/>}
              </div>
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='card pointer'>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}}>Email</div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-envelope color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-envelope color-success ml-1"/>}
              </div>
            </div>
          </div>

          <div className='col-sm-2'>
            <div className='card pointer'>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}}>SMS</div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-phone color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-phone color-success ml-1"/>}
              </div>
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='card pointer'>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}}>Chat</div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-comments color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-comments color-success ml-1"/>}
              </div>
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='card pointer'>
              <div className='card-header p-0 align-items-center' style={{textAlign: 'center'}}>Whatsapp</div>
              <div className='card-body align-items-center' style={{alignSelf: 'center'}}>
                {!data.incmsApiStatus && <IconProgress size={20} disableShrink/> }
                {data.incmsApiStatus === 'KO' && <i className="fa fa-2x fa-whatsapp color-danger ml-1"/>}
                {data.incmsApiStatus === 'OK' && <i className="fa fa-2x fa-whatsapp color-success ml-1"/>}
              </div>
            </div>
          </div>       
                 
        </div>

        <div className="text-right">
          <button className="btn btn-info" onClick={this.closeModal}><Translate id="close"/></button>
        </div>
        <AppInfoModalEvents open={appInfoModalEventOpened}
                      onClose={this.toggleAppInfoEventModal}
        />
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  updateApiStatus: ( data ) => {
    dispatch( updateApiStatus( data ) );
  }
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( AppInfoModal );




// WEBPACK FOOTER //
// ./routes/app/components/Navigation/AppInfoModal/index.js